'use strict'

export const SET_QUOTE_LIST = 'SET_QUOTE_LIST'
export const QUOTE_LIST_FETCHING = 'QUOTE_LIST_FETCHING'
export const QUOTE_LIST_ERROR = 'QUOTE_LIST_ERROR'
export const QUOTE_LIST_CLEAR_ERROR = 'QUOTE_LIST_CLEAR_ERROR'
// export const ADD_QUOTE_LIST = 'ADD_QUOTE_LIST'
export const UPDATE_QUOTE_LIST = 'UPDATE_QUOTE_LIST'
export const QUOTE_REJECTED = 'QUOTE_REJECTED'
export const QUOTE_ACCEPTED = 'QUOTE_ACCEPTED'
export const REQUEST_CANCELED = 'REQUEST_CANCELED'